export enum CardPanelType {
    Job = "Job",
    Contact = "Contact",
}
